import { render, staticRenderFns } from "./VerificationCallInfo.vue?vue&type=template&id=20f80d27"
import script from "./VerificationCallInfo.vue?vue&type=script&lang=js"
export * from "./VerificationCallInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports